var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("template-listing-item-base", {
    attrs: {
      id: _vm.template.Id,
      name: _vm.template.Name,
      date: _vm.template.Modified,
      "can-delete": _vm.canDelete,
      "can-edit": _vm.canEdit
    },
    on: {
      "template-deleted": function($event) {
        return _vm.$emit("template-deleted", $event)
      },
      "template-selected": function($event) {
        return _vm.$emit("template-selected", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "sub-text-label",
        fn: function(ref) {
          var formattedDate = ref.formattedDate
          return [
            _vm._v(
              "\n       " +
                _vm._s(
                  _vm.resource("TemplateDraftListingItem_Item_SubTextLabel")
                ) +
                " " +
                _vm._s(formattedDate) +
                "\n    "
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }